import { render } from "./ChooseCenterCard.vue?vue&type=template&id=56c5bfb0&scoped=true&ts=true"
import script from "./ChooseCenterCard.vue?vue&type=script&lang=ts"
export * from "./ChooseCenterCard.vue?vue&type=script&lang=ts"

import "./ChooseCenterCard.vue?vue&type=style&index=0&id=56c5bfb0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c5bfb0"]])

export default __exports__